import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface Flash extends SVGProps<SVGSVGElement> {
  label?: string
}

const Flash: React.FC<Flash> = ({ label = 'flash', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.66667 1.33334L3.33333 9.33334H7.33333L7.33333 14.6667L12.6667 6.66668H8.66667V1.33334Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default Flash
